var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var extractFormFieldHelperProps = function (props) {
    var _a, _b;
    return ({
        errorNotification: __assign({ show: !!((_a = props.errorNotification) === null || _a === void 0 ? void 0 : _a.message) }, props.errorNotification),
        contextualHelp: __assign({ show: !!((_b = props.contextualHelp) === null || _b === void 0 ? void 0 : _b.content) &&
                props.contextualHelp.variant === 'stacked' }, props.contextualHelp),
        characterCounter: __assign({ variant: props.variant, charCount: props.value.length, maxChars: props.maxLength }, props.characterCounter),
        nativeDescribedBy: props['aria-describedby'],
    });
};
var formTextPropsToFilter = [
    'variant',
    'labelContent',
    'contextualHelp',
    'className',
];
export var filterFormTextProps = function (props) {
    return Object.entries(props).reduce(function (acc, current) {
        var _a;
        var key = current[0];
        var value = current[1];
        if (formTextPropsToFilter.includes(key))
            return acc;
        return __assign(__assign({}, acc), (_a = {}, _a[key] = value, _a));
    }, {});
};
var textAreaPropsToFilter = [
    'children',
    'errorNotification',
    'characterCounter',
    'resizable',
    'textareaRef',
];
export var filterTextAreaProps = function (props) {
    return Object.entries(props).reduce(function (acc, current) {
        var _a;
        var key = current[0];
        var value = current[1];
        if (textAreaPropsToFilter.includes(key))
            return acc;
        return __assign(__assign({}, acc), (_a = {}, _a[key] = value, _a));
    }, {});
};
//# sourceMappingURL=utils.js.map